// extracted by mini-css-extract-plugin
export default {"subtitle":"PhoneConfirmationForm_subtitle__TbSqE","body":"PhoneConfirmationForm_body__0qahv","footer":"PhoneConfirmationForm_footer__u+Xk7"};